module.exports = __webpack_public_path__ + "static/img/award3.c149b02.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award3.png
// module id = EK0m
// module chunks = 7